import { useContext, useState, useEffect, useRef } from 'react';

import styles from './ConferenceScreenComponent.module.css'

import { GlobalContext } from "../../contexts/globalContext";
import { AddConferenceProvider } from "../../contexts/addConferenceContext";
import { ProjectDetailsProvider } from "../../contexts/projectDetailsContext";

import WaitingForJoiningScreen from './WaitingForJoiningScreen';
import MediasoupConferenceComponentNew from './MediasoupConferenceComponentNew';
import TopicsComponent from './TopicsComponent';
import SideMenuComponent from './SideMenuComponent';
import RegisterNewVisitor from './RegisterNewVisitor';
import PdfFileComponent from '../../files/PdfFileComponent';
import ImageFileComponent from '../../files/ImageFileComponent';
import VideoFileComponent from '../../files/VideoFileComponent';
// import SiteFileComponent from '../../files/SiteFileComponent';

import videoSource from '../../graphics/big wave fundal loop_6.mp4';


const ConferenceScreenComponent = () => {
    const {
        keyboardRef, setTopics, deskData, setCurrentConference, setCurrentTopic, currentTopic, waitingForJoining, setWaitingForJoining, setConferencePaused, currentParticipant,
        sharedFiles, openedFiles, socketRef, setOpenedFiles, setSharedFiles, currentConference, appHeight, appWidth, iamSubAdministrator, extraScreenOpenConf,
        localSocketRef
    } = useContext(GlobalContext);

    const currentConferenceRef = useRef();
    const currentParticipantRef = useRef();
    const sharedFilesRef = useRef();
    const hideSubtitleTimeoutRef = useRef();

    const [panelIsDown, setPanelIsDown] = useState(true);
    const [showVideo, setShowVideo] = useState(false);
    const [subtitle, setSubtitle] = useState("");


    async function fetchTranslation(text, fromLang, targetLang) {
        console.log("fetchTranslation", text, fromLang, targetLang);
        if (targetLang.toLowerCase() === 'gb' || targetLang.toLowerCase() === 'us')
            targetLang = 'en';

        const url = `https://api.mymemory.translated.net/get?q=${encodeURIComponent(text)}&langpair=${fromLang}|${targetLang}`;
        console.log("fetchTranslation", url);
        const response = await fetch(url);
        if (!response.ok) throw new Error("Eroare API");
        const data = await response.json();
        return data.responseData.translatedText;
    }

    // Pipeline-ul care se ocupă de traducerea simultană în fundal
    async function executeTranslationPipeline(text, fromLang, targetLang) {
        try {
            // Trimitem ambele cereri de rețea în paralel (viteză maximă)
            const [tradus] = await Promise.all([
                fetchTranslation(text, fromLang, targetLang),
                //fetchTranslation(text, 'fr')
            ]);

            // Adăugăm traducerile în zonele de istoric
            setSubtitle(tradus);
        } catch (error) {
            console.error("Eroare la traducerea automată:", error);
        }
    }

    useEffect(() => {
        if (hideSubtitleTimeoutRef.current) {
            clearTimeout(hideSubtitleTimeoutRef.current);
        }
        hideSubtitleTimeoutRef.current = setTimeout(() => {
            setSubtitle("");
        }, 5000);
    }, [subtitle]);

    useEffect(() => {
        currentConferenceRef.current = currentConference;
    }, [currentConference])

    useEffect(() => {
        currentParticipantRef.current = currentParticipant;
    }, [currentParticipant]);

    useEffect(() => {
        sharedFilesRef.current = sharedFiles;
    }, [sharedFiles]);

    useEffect(() => {

        localSocketRef.current?.on("serial:limitStatusUpdated", (status) => {
            setPanelIsDown(status.panel === "down");
        })

        const playVideosListener = function (conferenceId) {
            if (conferenceId === currentConference._id) {
                setShowVideo(true);
            }
        };

        const pauseVideosListener = function (conferenceId) {
            if (conferenceId === currentConference._id) {
                setShowVideo(false);
            }
        };

        socketRef.current.on('PLAY_VIDEOS', playVideosListener);
        socketRef.current.on('PAUSE_VIDEOS', pauseVideosListener);

        if (panelIsDown && localSocketRef.current?.connected) {
            setTimeout(async () => {

                if (currentConference.videoPaused) {
                    localSocketRef.current.emit("serial:liftPanel");
                } else {
                    localSocketRef.current.emit("serial:liftPanelAndCam");
                }

            }, 1000);
        }

        setOpenedFiles([]);
        setSharedFiles([]);

        if (socketRef.current) {
            socketRef.current.on('PAUSE_CONFERENCE', function (conferenceId) {
                if (conferenceId === currentConferenceRef.current._id) {
                    setConferencePaused(true);
                    setWaitingForJoining(true);
                    currentConferenceRef.current.paused = true;
                }
            });

            socketRef.current.on('ADD_SUBTITLE', function (conferenceId, subtitle, lang) {
                if (conferenceId === currentConferenceRef.current._id) {
                    console.log("ADD_SUBTITLE", lang, currentParticipantRef.current.country);
                    if (lang.includes(currentParticipantRef.current.country)) {
                        setSubtitle(subtitle);
                    } else {
                        executeTranslationPipeline(subtitle, lang.split('-')[0], currentParticipantRef.current.country);
                    }
                }
            });

            socketRef.current.on('PLAY_CONFERENCE', function (conferenceId) {
                if (conferenceId === currentConferenceRef.current._id && currentParticipantRef.current) {
                    setConferencePaused(false);
                    setWaitingForJoining(false);
                    currentConferenceRef.current.paused = false;
                }
            });

            socketRef.current.on('UPDATE_SHARED_DATA', (updatedShareData, conferenceId, fileUid, mustSaveInDB) => {
                if (conferenceId === currentConferenceRef.current._id) {

                    // Find the incoming record (if any) from the server payload
                    const incoming = updatedShareData?.find(f => f.uid === fileUid);

                    setSharedFiles(prev => {
                        const idx = prev.findIndex(f => f.uid === fileUid);

                        // Case 1: File was removed on the server -> remove locally (if present)
                        if (!incoming) {
                            return idx === -1 ? prev : [...prev.slice(0, idx), ...prev.slice(idx + 1)];
                        }

                        // Ensure we don't mutate the server object reference
                        const merged = { ...prev[idx], ...incoming, mustSaveInDB };

                        // Case 2: File exists locally -> replace in place (preserve order)
                        if (idx !== -1) {
                            // If nothing actually changed, return prev to avoid a rerender
                            const unchanged =
                                prev[idx] &&
                                Object.keys(merged).every(k => prev[idx][k] === merged[k]) &&
                                Object.keys(prev[idx]).every(k => merged[k] === prev[idx][k]);
                            if (unchanged) return prev;

                            const next = prev.slice();
                            next[idx] = merged;
                            return next;
                        }

                        // Case 3: New file -> append (or insert wherever you want)
                        return [...prev, merged];
                    });

                    currentConferenceRef.current.shared_data = JSON.stringify(updatedShareData);
                }
            })

            var aux_topic = currentConferenceRef.current?.topics?.find(topic => topic._id === currentConferenceRef.current.currentTopic);
            setCurrentTopic(aux_topic);


            socketRef.current.on('UPDATE_CURRENT_TOPIC', (topicId, conferenceId) => {
                if (conferenceId === currentConferenceRef.current._id) {

                    if (currentConferenceRef.current.type !== "Presentation") {
                        for (let i = 0; i < sharedFilesRef.current.length; i++) {
                            socketRef.current.emit("UPDATE_SHARE", currentConference._id, [], sharedFilesRef.current[i].uid);
                        }

                        currentConference.shared_data = JSON.stringify([]);
                        setSharedFiles([]);
                    }
                    if (topicId) {
                        var aux_topic = currentConferenceRef.current.topics.find(topic => topic._id === topicId);
                        setCurrentTopic(aux_topic);
                        currentConferenceRef.current.currentTopic = aux_topic._id;
                    } else {
                        setCurrentTopic(null);
                        currentConferenceRef.current.currentTopic = null;
                    }
                }
            })

            socketRef.current.on('DISCUSSION_OPENED', (conferenceId) => {
                if (conferenceId === currentConferenceRef.current._id) {
                    setCurrentConference({ ...currentConferenceRef.current, discussionOpened: true })


                }
            })
        }

        if (!deskData) {
            socketRef.current.emit("GET_CONFERENCE_BY_ID", currentConferenceRef.current._id, (callback) => {
                setCurrentConference(callback.response);


                setTopics(callback.response.topics);
            })
        }

        keyboardRef.current.hideIt();

        return () => {
            socketRef.current?.off('UPDATE_SHARED_DATA')
            socketRef.current?.off('PAUSE_CONFERENCE')
            socketRef.current?.off('LEAVE_CONFERENCE')
            localSocketRef.current?.off("serial:limitStatusUpdated");

            socketRef.current?.off('ADD_SUBTITLE')
            socketRef.current?.off('PLAY_CONFERENCE')
            socketRef.current?.off('UPDATE_CURRENT_TOPIC')
            socketRef.current?.off('PLAY_VIDEOS', playVideosListener);
            socketRef.current?.off('PAUSE_VIDEOS', pauseVideosListener);
        }
    }, [])

    useEffect(() => {
        if (!waitingForJoining) {
            setSharedFiles([]);

            if (currentConference.shared_data) {
                setSharedFiles(JSON.parse(currentConference.shared_data));
            }

            if (currentConference.type === "Presentation" && (currentParticipant?._id === currentConference.moderatedBy || iamSubAdministrator)) {
                setConferencePaused(false);
            } else {
                if (currentConference.paused) {
                    setConferencePaused(true);
                    setWaitingForJoining(true);
                } else {
                    setConferencePaused(false);
                    setWaitingForJoining(false);
                }
            }
        }
    }, [waitingForJoining])

    const GetFileComponent = (file, shared) => {
        switch (file.type) {
            case "pdf":
                return <PdfFileComponent key={file.uid} shared={shared} file={file}></PdfFileComponent>
            case "image":
                return <ImageFileComponent key={file.uid} shared={shared} file={file}></ImageFileComponent>
            case "video":
                return <VideoFileComponent key={file.uid} shared={shared} file={file}></VideoFileComponent>
            // case "site":
            //     return <SiteFileComponent key={file.uid} shared={shared} file={file}></SiteFileComponent>
            default:
                return "";
        }
    }

    return (
        <div className={styles.component}>
            <AddConferenceProvider>
                <video id="background-video" autoPlay loop playsInline muted style={{ position: "absolute", height: `${appHeight}px`, width: `${appWidth}px` }}>
                    <source src={videoSource} type="video/mp4" />
                </video>

                {waitingForJoining && !currentParticipant && <RegisterNewVisitor></RegisterNewVisitor>}

                {waitingForJoining && currentParticipant && <WaitingForJoiningScreen SetWaitingForJoining={setWaitingForJoining} />}
                {!waitingForJoining && <MediasoupConferenceComponentNew />}


                {!waitingForJoining && <TopicsComponent />}



                {!waitingForJoining && !extraScreenOpenConf && sharedFiles.map((file) => (
                    GetFileComponent(file, true)
                ))}

                {!waitingForJoining && openedFiles.map((file) => (
                    GetFileComponent(file, false)
                ))}

                {!waitingForJoining &&
                    <ProjectDetailsProvider>
                        <SideMenuComponent />
                    </ProjectDetailsProvider>
                }

                {!waitingForJoining && currentTopic && (currentConference.type !== "Presentation" || !showVideo || currentConference.moderatedBy === currentParticipant?._id) &&
                    <div style={{ width: "100%", position: "absolute", display: "flex", justifyContent: "center" }}>
                        <div style={{ backgroundColor: "#292148", padding: "30px 60px", borderRadius: "0px 0px 10px 10px", font: "normal normal 600 50px/44px Bio Sans", color: "#C3C2CA" }}>{currentTopic.name}</div>
                    </div>
                }

                <div style={{ textAlign: "center", position: "absolute", bottom: "0px", right: "0px", width: "100%", padding: "30px 60px", borderRadius: "0px 0px 10px 10px", font: "normal normal 600 50px/44px Bio Sans", color: "#C3C2CA" }}> {subtitle}</div>

            </AddConferenceProvider>
        </div>
    );
}

export default ConferenceScreenComponent;